// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class PfixEntitlementSubscriptionHistoryRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_PRODUCT_SUBSCRIPTION_HISTORY_REQ, fieldSet);
    }
    getFromUtc() {
        return this.getFieldValue(FieldsFactory.FIELD_START_TIME);
    }
    setFromUtc(value) {
        this.setFieldValue(FieldsFactory.FIELD_START_TIME, value);
    }
    getToUtc() {
        return this.getFieldValue(FieldsFactory.FIELD_END_TIME);
    }
    setToUtc(value) {
        this.setFieldValue(FieldsFactory.FIELD_END_TIME, value);
    }
}
